import { Box, Checkbox } from '@eatclubapp/ec-component-library';
import { MenuItem, useTheme } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { TextField } from '../TextField';
import { Typography } from '../Typography';

const CustomBookingFields = ({ fields, values, errors, onChange }) => {
  const theme = useTheme();

  if (fields.length === 0) {
    return null;
  }

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {fields.map((field) => {
        const error = errors[field.id];
        const commonProps = {
          required: field.required,
          error: Boolean(error),
          helperText: error && <Typography variant='caption'>{error}</Typography>,
          label: field.name,
          value: values[field.id] ?? '',
          onChange: (event) => onChange(field.id, event.target.value),
          InputProps: { disableUnderline: true },
          name: `custom-field-${field.id}`,
        };

        if (field.type === 'checkbox') {
          return (
            <Box key={field.id}>
              <Checkbox
                label={<Typography variant='small'>{field.name}</Typography>}
                color={theme.colors.charcoal}
                onChange={(selected) => onChange(field.id, selected)}
                selected={values[field.id] === true}
                style={{ checkboxBox: { backgroundColor: 'transparent' } }}
              />
              {error && <Typography variant='caption'>{error}</Typography>}
            </Box>
          );
        }

        if (field.type === 'list') {
          return (
            <TextField key={field.id} select {...commonProps}>
              <MenuItem value=''>Select an option</MenuItem>
              {(field.options?.listValues || []).map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          );
        }

        return (
          <TextField
            key={field.id}
            {...commonProps}
            type={field.type === 'number' ? 'number' : field.type === 'date' ? 'date' : 'text'}
            {...(field.type === 'date' && { InputLabelProps: { shrink: true } })}
            {...(field.type === 'link' && { inputProps: { inputMode: 'url' } })}
          />
        );
      })}
    </Box>
  );
};

CustomBookingFields.defaultProps = {
  fields: [],
  values: {},
  errors: {},
};

CustomBookingFields.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({})),
  values: PropTypes.shape({}),
  errors: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};

export default CustomBookingFields;
